import React from 'react'

export const BookABookContext = React.createContext();